import { Reducer } from "redux";
import { ActionTypes, TaskActions } from "./TaskActionTypes";
import { ITaskState, TaskState } from "./TaskState";

export const initialState: ITaskState = new TaskState();

const reducer: Reducer<ITaskState> = (state: ITaskState = initialState, action: TaskActions) => {
    switch (action.type) {
        case ActionTypes.CSV_DOWNLOADED:
            return { ...state, hasDownloaded: true };
        case ActionTypes.CLEAR:
            return { ...state, hasDownloaded: false };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/Store/Tasks/TaskReducer.ts